module.exports = __webpack_public_path__ + "static/img/power-line_256.d193954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/power-line_256.png
// module id = RiXP
// module chunks = 0